export default __webpack_public_path__ + "static/media/7.abc58bd8.JPG";